import React, { useState, useEffect } from "react";
import home_background1 from '../../Assets/Images/home_background1.jpg';
import home_background2 from '../../Assets/Images/home_background2.jpg';
import Unlimited_Instructions_image from '../../Assets/Images/StaticImages/unlimited_1.png';
import Description_image from '../../Assets/Images/StaticImages/unlimited_2.png';
import "./unlimitedinstruction.css";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import HeroSectionCom from "../../Components/InstructionsCom/HeroSectionCom";
import DescriptionSectionCom from "../../Components/InstructionsCom/DescriptionSectionCom";
import { useNavigate, useSearchParams } from "react-router-dom";
import SEO from "../../Components/SEO";
import bg from '../../Assets/Images/StaticImages/unlimheaderbg.png';




const UnlimitedInstruction = () => {
  const navigate = useNavigate();
    const [searchParams] = useSearchParams();
  const id = searchParams.get("id");   // gets id from ?id=5
  const user = JSON.parse(localStorage.getItem("user"));
  let url = ``;
  if(!user || user.role !== "PARENT"){
    localStorage.clear();
     url = `/packages-new/${id}`;
  }else{

    url = `/packages/${id}`;
  }
const descriptionPoints = [
  "Group Instruction",
  "Come in every day that we train for 1 hour (max) (4-5 times a week)",
  "Financially beneficial if you can get in the gym 2x a week",
  "Flexible Schedule: Come in any day that we train at any location available for 1 hour.",
  "Multiple gym locations (North & South Shore of Staten Island)",
  "Plan renews monthly on the date that you start. You may start at any time.",
  "6 hour cancellation policy (1 session is deducted from your account if you cancel within 6 hours of your scheduled session)",
  "All sessions are non-transferable"
];
 
  return (
    <>
      <SEO
        title="Unlimited Instruction - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/unlimited-instruction"
      />
      <StaticPageHeaders title="Unlimited Instructions" headerBg={bg}/>
      <HeroSectionCom
        title="Unlimited Instruction"
        image={Unlimited_Instructions_image}
        description={descriptionPoints}
        buttonLink={url}
      />
      <DescriptionSectionCom
        title="Description"
        image={Description_image}
        description={descriptionPoints}
      />

      
    </>
  );
};
export default UnlimitedInstruction;
